import styled, { css } from 'styled-components';

import { utils } from '@desygner/ui-common-components';

const PRESETS = {
  height: utils.rem(40),
  top: utils.rem(11),
  left: utils.rem(-13),
  rotate: '180deg',
};

export const StyledTooltipIconWrapper = styled.div(({ theme }) => {
  return css`
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
    top: ${PRESETS.top};
    left: ${PRESETS.left};
    rotate: ${PRESETS.rotate};
  `;
});

export const StyledTitleLabel = styled.div(({ theme }) => {
  return css`
    height: ${PRESETS.height};
    background-color: ${theme.Color.Brand.Primary};
    display: flex;
    align-items: center;
    justify-content: center;
    padding-left: ${utils.rem(theme.Spacing.Size.Medium)};
    padding-right: ${utils.rem(theme.Spacing.Size.Medium)};
    border-radius: ${utils.rem(theme.Border.Radius.Medium)};
    position: relative;
  `;
});
